import React from "react";
import { FormColWrapper } from "./styled";

interface Props {
  label: string;
  name?: string;
  type?: "text" | "textarea" | "button";
  btnPosition?: "left" | "center" | "right";
  onChange?: (e: React.SyntheticEvent<HTMLInputElement>) => void;
}

const FormCol: React.FC<Props> = ({
  label,
  name,
  onChange,
  type = "text",
  btnPosition,
}) => {
  const formColMarkup = (type: string) => {
    switch (type) {
      case "textarea":
        return <textarea name={name}></textarea>;
      case "button":
        return (
          <button disabled type="submit">
            <span>{label}</span>
            <i className="las la-chevron-right"></i>
          </button>
        );
      default:
        return <input type={type} name={name} onChange={onChange} />;
    }
  };

  return (
    <FormColWrapper btnPosition={btnPosition}>
      <label>
        {type !== "button" && <span>{label}</span>}
        {formColMarkup(type)}
      </label>
    </FormColWrapper>
  );
};

export default FormCol;
